<script>
export default {
  components: {},
  props: {
    mainColor: {
      type: String,
      default: '',
    },
    mainColorTwo: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isMobile: false,
      show: false,
    }
  },
  computed: {},
  mounted() {},
  methods: {},
}
</script>
<template>
  <div class="box">
    <svg xmlns="http://www.w3.org/2000/svg" :width="'100%'" :height="'100%'" viewBox="0 0 1922.812 335.113">
      <g id="Group_14316" data-name="Group 14316" transform="translate(16787.205 20516.004)">
        <path
          id="Path_30823"
          data-name="Path 30823"
          d="M0,0S338.334,135.047,853.586,170.6c304.6,21.018,672.577,15,1068.545-97.969-.087,59.3,0,227.369,0,227.369H.131Z"
          transform="translate(-16787.205 -20480.891)"
          fill="#fff"
        />
        <g id="Group_14307" data-name="Group 14307">
          <g id="Group_14306" data-name="Group 14306" transform="translate(-16786 -21179)">
            <path
              id="Path_10968"
              data-name="Path 10968"
              d="M3721.543,4990.852c-.021-.012.063,39.2.063,39.2C3456.752,5101.439,3176,5140,2885,5140c-382.4,0-727.568-65.959-1084.848-185.328C1800.242,4954.16,2674.655,5250.834,3721.543,4990.852Z"
              transform="translate(-1800 -4251.891)"
              :fill="mainColorTwo"
            />
            <path
              id="Path_10970"
              data-name="Path 10970"
              d="M3902.511,5009.885c.018.024,0,20.113,0,20.113s-596.925,110-915.328,110c-349.376,0-691.84-62.643-1007.228-153.287.036-.341.053-52.7.041-52.73C2530.021,5133.891,3184.687,5179.28,3902.511,5009.885Z"
              transform="translate(-1980.971 -4270.891)"
              :fill="mainColor"
            />
            <path
              id="Path_10971"
              data-name="Path 10971"
              d="M1979.764,5023.252s417.3,142.184,754.484,155c75.82,2.638,191.747-3.461,196.955-4.605-73.376-2.988-117.754-3.58-265.548-18.7-41.027-5.011-89.815-11.565-149.3-20.225-.949-.138-55.614-9.441-117.1-22.064s-189.118-35.9-419.278-117.557Z"
              transform="translate(-1980.969 -4332.109)"
              :fill="mainColorTwo"
              style="mix-blend-mode: multiply;isolation: isolate"
            />
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>
<style lang="scss" scoped>
.box {
  width: 100%;
  position: absolute;
  bottom: -11%;
  z-index: 5;
  @media screen and (max-width: 1500px) {
    bottom: -7%;
  }
  // @include max-lg {
  //   bottom: 0%;
  // }
}
</style>
